import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Buefy
import Buefy from 'buefy';

// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faKey,
  faLock,
  faUserPlus,
  faLink,
  faArrowRight,
  faChevronRight,
  faExclamationTriangle,
  faEnvelope,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faKey,
  faLock,
  faUserPlus,
  faLink,
  faArrowRight,
  faChevronRight,
  faExclamationTriangle,
  faEnvelope,
  faPhone
);

const app = createApp(App);

app.use(router);
app.use(Buefy);
app.component('FontAwesomeIcon', FontAwesomeIcon);

app.mount('#app');
